/**************************************************
 * Nombre:       Tarjeta_Vista_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Img_Producto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                height: 500,
                width: 400,
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 69.67%, #000 100%), url(${item})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                px: 3,
                py: 4
            }}
        >




        </Grid>
    )

}
export default Tarjeta_Img_Producto

